module.exports = __webpack_public_path__ + "static/media/IntroEndFrame.1962c3b1.png";